import { CSP_NONCE, Inject, Injectable, NgZone, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RokezzzWindowService } from '../../window/services/window.service';
import { RokezzzPlatformService } from '../../platform/services/platform.service';
import { first, Subscription, timer } from 'rxjs';
import { coreConfig } from 'src/app/core/models/core-config';
import { OnFinish } from '../../api/api/on-finish';

@Injectable({
    providedIn: 'root'
})
export class Ga4Service {
    private readonly ga4ApiKey: string = environment.ga4ApiKey;

    private gaLoaded: boolean = false;
    private gaLoading: boolean = false;
    private renderer: Renderer2;
    private document: Document;
    private timerSubscription?: Subscription;

    public constructor(
        @Inject(CSP_NONCE) private readonly cspNonce: string,
        private readonly rokezzzWindowService: RokezzzWindowService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
        private readonly rendererFactory: RendererFactory2,
        private readonly ngZone: NgZone
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.document = this.rokezzzWindowService.getDocument();
    }

    public async init(forceGenerate?: boolean): Promise<void> {
        this.sendToAnalytics((): void => { }, forceGenerate);
    }

    private sendToAnalytics(onFinish: OnFinish<void>, forceGenerate?: boolean): void {
        if (this.rokezzzPlatformService.isPlatformServer()) {
            return;
        }

        if (this.gaLoaded) {
            onFinish();

            return;
        }

        if (forceGenerate) {
            this.generateScripts();

            return;
        }

        if (this.gaLoading) {
            this.ngZone.runOutsideAngular((): void => {
                timer(1000).pipe(
                    first()
                ).subscribe(async (): Promise<void> => {
                    this.ngZone.run((): void => {
                        this.sendToAnalytics(onFinish);
                    });
                });
            });

            return;
        }

        this.gaLoading = true;

        this.ngZone.runOutsideAngular((): void => {
            this.timerSubscription = timer(coreConfig.externalScriptLoadDelay).pipe(
                first()
            ).subscribe(async (): Promise<void> => {
                this.ngZone.run((): void => {
                    this.generateScripts();
                });
            });
        });
    }

    private generateScripts(): void {
        this.timerSubscription?.unsubscribe();

        const mainScriptElement: HTMLScriptElement = this.renderer.createElement('script') as HTMLScriptElement,
            scriptElement: HTMLElement = this.renderer.createElement('script'),
            inlineScript = this.renderer.createText(`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${this.ga4ApiKey}');`);

        mainScriptElement.nonce = this.cspNonce;
        mainScriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${this.ga4ApiKey}`;
        mainScriptElement.async = true;
        scriptElement.nonce = this.cspNonce;
        this.renderer.appendChild(this.document.head, mainScriptElement);
        this.renderer.appendChild(scriptElement, inlineScript);
        this.renderer.appendChild(this.document.head, scriptElement);
        this.gaLoaded = true;
        this.gaLoading = false;
    }
}
